import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

class LeadsService {
  static async getUrlMetaLeads(customerId: number) {
    const url = `/leads/meta/login?customer_id=${customerId}`;
    const response = await poliApiGatewayRequest.get(url);
    return response?.data?.url;
  }

  static async getCallbackMetaLeads(
    code: string,
    customerId: number
  ) {
    const url = `/leads/meta/callback?customer_id=${customerId}`;
    const response = await poliApiGatewayRequest.post(url, {
      token: code,
    });
    return response;
  }

  static async getStatusLeads(customerId: number) {
    const url = `/leads/meta/status?customer_id=${customerId}`;
    const response = await poliApiGatewayRequest.get(url);
    return response;
  }

  static async deleteMetaLeads(customerId: number) {
    const url = `/leads/token/${customerId}?customer_id=${customerId}`;
    const response = await poliApiGatewayRequest.delete(url);
    return response;
  }
}

export default LeadsService;
